<template>
  <div class="mr-bot-wrapper">
    <div class="bot-thrusters-glow-bg animate-glow" :style="'background-image: url('+bot_glow_bg+');'"></div>
    <div class="bot-thrusters-glow-main animate-glow" :style="'background-image: url('+bot_glow_main+');'"></div>
    <div class="bot-thrusters-bg" :style="'background-image: url('+bot_thrusters_bg+');'"></div>
    <div class="mr-bot" :style="'background-image: url('+bot_body_bg+');'"></div>
    <dot-matrix class="eye _left" :dotcolor="'43, 161, 223'" :cols="3" :rows="3" :pattern="patterns.eyes.hisleft"
      :dotsize="6" :dotgap="2"></dot-matrix>
    <dot-matrix class="eye _right" :dotcolor="'43, 161, 223'" :cols="3" :rows="3" :pattern="patterns.eyes.hisright"
      :dotsize="6" :dotgap="2"></dot-matrix>
    <dot-matrix class="body-display" :dotcolor="'43, 161, 223'" :cols="7" :rows="6" :pattern="patterns.bot_body.initial"
      :dotsize="10" :dotgap="4"></dot-matrix>
    <div class="bot-arm-shadow" :style="'background-image: url('+bot_arm_shadow+');'"></div>
    <div class="bot-arm" :style="'background-image: url('+bot_arm+');'"></div>
    <div class="bot-reflections" :style="'background-image: url('+bot_reflections+');'"></div>
    <div class="bot-thrusters-fg" :style="'background-image: url('+bot_thrusters_fg+');'"></div>
  </div>
</template>

<script>

import dotMatrix from '.././dotMatrix.vue';

import botBody from '../.././assets/bot-body-optimized.png';
import botReflections from '../.././assets/bot-reflections.png';
import botThrustersBg from '../.././assets/bot-thrusters-bg-optimized.png';
import botThrustersFg from '../.././assets/bot-thrusters-fg-optimized.png';
import botArm from '../.././assets/bot-arm.png';
import botArmShadow from '../.././assets/bot-arm-shadow.png';
import botThrustersGlowBg from '../.././assets/bot-thrusters-glow-bg-optimized.png';
import botThrustersGlowClose from '../.././assets/bot-thrusters-glow-close-optimized.png';

import {mapGetters} from 'vuex';

export default {
  name: 'mrBot',
  data() {
    return {
      exclude_from_nav: true,
      animationsDone: false,
      animationsInit: false,
      bot_body_bg: botBody,
      bot_reflections: botReflections,
      bot_thrusters_fg: botThrustersFg,
      bot_thrusters_bg: botThrustersBg,
      bot_arm_shadow: botArmShadow,
      bot_glow_bg: botThrustersGlowBg,
      bot_glow_main: botThrustersGlowClose,
      bot_arm: botArm,
      timelines: {
        eyes_loading: null,
        thrusters: null,
        liftoff: null,
        hover: null
      },
      patterns: {
        bot_body: {
          initial: [
            0, 1, 0, 0, 0, 1, 0,
            1, 1, 1, 0, 1, 1, 1,
            1, 1, 1, 1, 1, 1, 1,
            0, 1, 1, 1, 1, 1, 0,
            0, 0, 1, 1, 1, 0, 0,
            0, 0, 0, 1, 0, 0, 0
          ]
        },
        eyes: {
          hisleft: [
            1, 1, 1,
            1, 1, 1,
            1, 1, 1
          ],
          hisright: [
            1, 1, 1,
            1, 1, 1,
            1, 1, 1
          ]
        }
      }
    };
  },
  watch: {
    active_section_name(val) {
      if (val === 'passion') {
        if (!this.is_animating_scroll) { // && window.innerWidth > 1024
          this.runSectionAnimations();
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      active_section_name: 'getActiveSectionName',
      is_animating_scroll: 'getAnimatingScrollState'
    })
  },
  mounted() {
    this.addEyesLoadingTimeline();
    this.addThrustersTimeline();
    this.addFlightTimeline();
    this.addHoverAnimation();
  },
  methods: {
    runSectionAnimations() {
      if (this.animationsDone || this.animationsInit) return;
      this.timelines.eyes_loading.play();
      this.timelines.thrusters.play();
      this.timelines.liftoff.play();
      this.animationsInit = true;
    },
    setMood(mood) {
      switch (mood) {
        case 'angry' :
          this.patterns.eyes.hisleft = [
            0, 0, 1,
            1, 1, 1,
            1, 1, 0
          ];
          this.patterns.eyes.hisright = [
            1, 0, 0,
            1, 1, 1,
            0, 1, 1
          ];
          break;
        case 'cheerful' :
          this.patterns.eyes.hisleft = [
            0, 1, 0,
            1, 1, 1,
            1, 0, 1
          ];
          this.patterns.eyes.hisright = [
            0, 1, 0,
            1, 1, 1,
            1, 0, 1
          ];
          break;
        case 'test' :
          this.patterns.eyes.hisleft = [
            1, 1, 1,
            0, 1, 1,
            0, 0, 1
          ];
          this.patterns.eyes.hisright = [
            1, 1, 1,
            1, 1, 0,
            1, 0, 0
          ];
          break;
      }
    },
    addHoverAnimation() {
      this.timelines.hover = new TimelineMax({
        repeat: -1,
        yoyo: true
      });

      this.timelines.hover.fromTo(this.$el, 2, {
        y: (window.innerWidth < 769) ? -700 : -980
      }, {
        y: (window.innerWidth < 769) ? -770 : -1050,
        ease: Power1.easeInOut
      });
      TweenMax.set(this.$el, {
        y: 0
      });

      this.timelines.hover.pause();
    },
    addFlightTimeline() {
      TweenMax.set(this.$el, {
        y: 0
      });

      let _this = this;
      this.timelines.liftoff = new TimelineMax({
        repeat: 0,
        onComplete() {
          _this.timelines.hover.play();
          _this.timelines.eyes_loading.pause();
          _this.setMood('cheerful');
        }
      });
      let botarm = this.$el.querySelector('.bot-arm');
      let botarmshadow = this.$el.querySelector('.bot-arm-shadow');
      TweenMax.set(botarm, {
        autoAlpha: 0
      });
      TweenMax.set(botarmshadow, {
        autoAlpha: 0
      });

      this.timelines.liftoff.to(this.$el, 2, {
        y: (window.innerWidth < 769) ? -800 : -1100
      }).to(botarm, 1.6, {
        transformOrigin: '210px 70px',
        rotation: 50,
        ease: Power3.easeInOut
      }, 0).to(this.$el, 1.5, {
        y: (window.innerWidth < 769) ? -700 : -980,
        ease: Power1.easeInOut
      }).to(botarm, 1.2, {
        rotation: 0,
        ease: Power1.easeInOut
      }, 2);

      this.timelines.liftoff.pause();
    },
    addThrustersTimeline() {
      let thrusterBg = this.$el.querySelectorAll('.animate-glow');
      let thrusters = this.$el.querySelector('.bot-thrusters-bg');

      this.timelines.thrusters = new TimelineMax({
        repeat: -1,
        yoyo: true
      });

      this.timelines.thrusters.fromTo(thrusters, 0.08, {
        alpha: 0.8,
        y: -24
      }, {
        y: 0,
        alpha: 1,
        ease: TweenMax.RoughEase.ease.config({
          template: Power0.easeNone,
          strength: 1,
          points: 4,
          taper: 'none',
          randomize: false,
          clamp: false
        })
      }).fromTo(thrusterBg, 0.1, {
        alpha: 0.9,
        scale: 0.85
      }, {
        alpha: 1,
        scale: 1,
        ease: TweenMax.RoughEase.ease.config({
          template: Power0.easeNone,
          strength: 1,
          points: 4,
          taper: 'none',
          randomize: false,
          clamp: false
        })
      }, 0);

      this.timelines.thrusters.pause();
    },
    addEyesLoadingTimeline() {
      let _this = this;
      let animationProps = {
        frameCount: 0,
        frames: {
          left: [
            [
              1, 1, 0,
              1, 0, 0,
              1, 0, 0
            ], [
              1, 1, 1,
              1, 0, 0,
              0, 0, 0
            ], [
              1, 1, 1,
              0, 0, 1,
              0, 0, 0
            ], [
              0, 1, 1,
              0, 0, 1,
              0, 0, 1
            ], [
              0, 0, 1,
              0, 0, 1,
              0, 1, 1
            ], [
              0, 0, 0,
              0, 0, 1,
              1, 1, 1
            ], [
              0, 0, 0,
              1, 0, 0,
              1, 1, 1
            ], [
              1, 0, 0,
              1, 0, 0,
              1, 1, 0
            ], [
              1, 1, 0,
              1, 0, 0,
              1, 0, 0
            ]
          ],
          right: [
            [
              0, 1, 1,
              0, 0, 1,
              0, 0, 1
            ], [
              1, 1, 1,
              0, 0, 1,
              0, 0, 0
            ], [
              1, 1, 1,
              1, 0, 0,
              0, 0, 0
            ], [
              1, 1, 0,
              1, 0, 0,
              1, 0, 0
            ], [
              1, 0, 0,
              1, 0, 0,
              1, 1, 0
            ], [
              0, 0, 0,
              1, 0, 0,
              1, 1, 1
            ], [
              0, 0, 0,
              0, 0, 1,
              1, 1, 1
            ], [
              0, 0, 1,
              0, 0, 1,
              0, 1, 1
            ], [
              0, 1, 1,
              0, 0, 1,
              0, 0, 1
            ]
          ]
        }
      };

      this.timelines.eyes_loading = new TimelineMax({repeat: -1, repeatDelay: 0});
      this.timelines.eyes_loading.to(animationProps, 0.7, {
        frameCount: 8,
        ease: Power0.easeNone,
        onUpdate() {
          let frameArrIndex = Math.floor(animationProps.frameCount);
          _this.patterns.eyes.hisleft = animationProps.frames.left[frameArrIndex];
          _this.patterns.eyes.hisright = animationProps.frames.right[frameArrIndex];
        }
      });

      this.timelines.eyes_loading.pause();
    }
  },
  components: {
    dotMatrix
  }
};
</script>

<style lang="scss">

.tiny-dot-matrix {
  &.body-display {
    top: 309px;
    left: 352px;
    @media screen and (max-width: 1560px) {
      top: 174px;
      left: 286px;
      transform: scale(0.66);
    }

    .dot {
      box-shadow: none;
    }
  }

  &.eye {
    top: 92px;
    @media screen and (max-width: 1560px) {
      top: 27px;
    }

    &._right {
      left: 332px;
      transform: skewX(-3deg);
      @media screen and (max-width: 1560px) {
        left: 280px;
        transform: scale(0.66) skewX(-3deg);
      }
    }

    &._left {
      left: 400px;
      transform: skewX(-3deg);
      @media screen and (max-width: 1560px) {
        left: 326px;
        transform: scale(0.66) skewX(-3deg);
      }
    }

    .dot {
      border-radius: 50%;
      box-shadow: none;
    }
  }
}

.mr-bot-wrapper {
  width: 1048/2+px;
  position: absolute;
  z-index: 8000;
  right: 0;
  transform: translateY(0);

  > div {
    position: absolute;
    background-size: 100%;
  }

  @media screen and (max-width: 1560px) {
    width: 1048/3+px;
  }
  @media screen and (max-width: 768px) {
    transform: scale(0.7);
  }
  @media screen and (max-width: 640px) {
    display: none;
  }
}

.bot-reflections {
  top: 72px;
  left: 310px;
  width: 141/2+px;
  height: 673/2+px;
  @media screen and (max-width: 1560px) {
    top: 22px;
    left: 270px;
    width: 141/3+px;
    height: 673/3+px;
  }
}

.bot-thrusters-fg {
  width: 773/2+px;
  height: 211/2+px;
  top: 1020px;
  left: 204px;
  @media screen and (max-width: 1560px) {
    width: 773/3+px;
    height: 211/3+px;
    top: 652px;
    left: 204px;
  }
}

.bot-thrusters-bg {
  width: 919/2+px;
  height: 495/2+px;
  top: 990px;
  left: 174px;
  @media screen and (max-width: 1560px) {
    width: 919/3+px;
    height: 495/3+px;
    top: 640px;
    left: 180px;
  }
}

.bot-thrusters-glow-bg {
  //border: 1px solid red;
  width: 2444/2+px;
  height: 2742/2+px;
  right: -200px;
  top: 400px;
  border-bottom-left-radius: 500px;
  @media screen and (max-width: 1560px) {
    width: 2444/4+px;
    height: 2742/4+px;
    right: -200px;
    top: 200px;
  }
}

.bot-thrusters-glow-main {
  //border: 1px solid red;
  width: 1912/2+px;
  height: 1586/2+px;
  top: 700px;
  right: -290px;
  border-bottom-left-radius: 500px;
  @media screen and (max-width: 1560px) {
    width: 1912/4+px;
    height: 1586/4+px;
    top: 450px;
    right: -240px;
  }
}

.mr-bot {
  position: absolute;
  width: 100%;
  right: -200px;
  top: -80px;
  padding-bottom: 220.29%;
  background-size: 100%;
}

</style>




// WEBPACK FOOTER //
// src/components/sections/Mrbot.vue